import { render } from "./ImageHeader.vue?vue&type=template&id=1fcbde49&scoped=true"
import script from "./ImageHeader.vue?vue&type=script&lang=js"
export * from "./ImageHeader.vue?vue&type=script&lang=js"

import "./ImageHeader.vue?vue&type=style&index=0&id=1fcbde49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcbde49"]])

export default __exports__